module.exports = __webpack_public_path__ + "static/media/bau_logo.7eb7346c.png";